import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-brand-darker" data-id="element-164">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="prose prose-lg prose-invert mx-auto text-center mb-20" data-id="element-166">
          <p className="text-xl md:text-2xl leading-relaxed text-zinc-300 mb-8" data-id="element-167">
            ¿Cuántas veces pagaste el mes del gimnasio para terminar yendo solo
            dos veces? La falta de tiempo, el tráfico y las salas llenas de
            gente son los asesinos silenciosos de tu progreso físico. Miras tu
            living y solo ves un lugar para ver series, pero ahí mismo tienes
            guardado el cuerpo que siempre quisiste.
          </p>
          <p className="text-xl md:text-2xl leading-relaxed text-zinc-300" data-id="element-168">
            El problema no es tu falta de voluntad. El problema es que te han
            hecho creer que sin máquinas de miles de dólares o barras olímpicas
            no puedes ganar músculo ni perder grasa. Te venden la idea de que
            necesitas "el suplemento del mes" o "la última app de moda" que solo
            te llena de notificaciones molestas que terminas ignorando.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-169">
          <h2 className="text-3xl md:text-4xl text-center mb-12 uppercase" data-id="element-170">
            POR QUÉ LO QUE INTENTASTE{' '}
            <span className="text-brand-orange" data-id="element-171">ANTES NO FUNCIONÓ</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-172">
            {['Las rutinas genéricas de YouTube no tienen una progresión lógica y solo te aburren a la segunda semana.', 'Las apps de fitness requieren suscripciones eternas y no se adaptan a la realidad de tu espacio o tus muebles.', 'Los planes de influencers están diseñados para gente que vive en el gimnasio, no para personas reales con trabajos y poco tiempo.', 'Intentaste entrenar en casa sin guía y terminaste haciendo siempre los mismos 3 ejercicios sin ver cambios en el espejo.'].map((text, index) => <div key={index} className="bg-zinc-900/50 border border-zinc-800 p-6 rounded-xl flex items-start gap-4" data-id="element-173">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-174" />
                <p className="text-zinc-300" data-id="element-175">{text}</p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}